//@ts-check
import { curatorApiClient } from '../../utils/RequestClient';

/**
 * @param {object} params
 * @param {AbortSignal} [params.signal]
 * @returns {Promise<import('@action-types/exchange-ui').ExchangeUiResponse>}
 * @throws {import('@action-types/RequestError').RequestError<import('@action-types/common').CuratorApiErrorResponse>}
 */
const getExchangeUiStaticData = async ({ signal }) => {
  const { jsonResponse } = await curatorApiClient.fetch({
    endpoint: `/exchangeui`,
    requestOptions: {
      signal,
      headers: {
        accept: 'application/json',
      },
    },
  });
  return jsonResponse;
};

export default getExchangeUiStaticData;
